import React from 'react';
import { Link } from 'react-router-dom';
import { FMessage } from '../../hoc/IntlComponents';
import WarningBlock from './WarningBlock';
import { STATIC_PATH } from '../../config';
import { AttensionBlock } from './AttensionBlock';

const FBApiRequestsGuide = () => (
  <div className="guide">
    <h6>
      <b>
        <FMessage id="transfer-by-api.nav.landing.guide.title" />
      </b>
    </h6>
    <WarningBlock />
    <AttensionBlock />
    <br />
    <b>
      <p className="questions-header">
        <FMessage id="transfer-by-api.nav.fb.guide" />
      </p>
    </b>
    <ol>
      <li>
        <p>
          <FMessage id="transfer-by-api.nav.fb.guide.part-1" />
          <a href="https://zapier.com/" target="_blank">
            zapier.com
          </a>
        </p>
      </li>
      <li>
        <p>
          <FMessage id="transfer-by-api.nav.fb.guide.part-2" />{' '}
          https://api.offerrum.com/webmaster/order/?key=КЛЮЧ&source=fb&flow=ПОТОК&subid=IDформы
          <FMessage id="transfer-by-api.nav.fb.guide.part-2.end" />
        </p>
      </li>
    </ol>
    <div className="transfer-img">
      <img src={`${STATIC_PATH}/img/transfer-by-api/img6.png?2`} />
    </div>
    <p>
      <FMessage id="transfer-by-api.nav.fb.guide.part-3" />
    </p>
    <WarningBlock id={'transfer-by-api.nav.fb.guide.part-3.warning'} />
    <p className="warning">
      <b>
        <FMessage id="transfer-by-api.warning.fb" />
      </b>
    </p>
    <p className="warning-wrapper no-margin">
      <FMessage id="transfer-by-api.guide.more-info-1" />
      <Link to="/faq/tools/integrations/setup/fb">
        <FMessage id="transfer-by-api.guide.more-info-2" />
      </Link>
      .
    </p>
  </div>
);

export default FBApiRequestsGuide;
